import api from '~/utils/api'
import { createGrowthEventId, getGrowthEventAnonymousId, getGrowthEventSessionId } from '~/utils/growthEvents'
import { deliverGrowthEvent } from '~/utils/playback-events.mjs'

export type PlaybackSurface = 'music_discovery' | 'music_ranking' | 'song_page' | 'share_page' | 'feed' | 'chart' | 'home' | 'player' | 'search'
export interface PlaybackContext { surface?: PlaybackSurface; requestId?: string; position?: number }
const config = { headers: { 'Content-Type': 'application/json' }, musicmintInlineError: true }

export async function songRequest(path: string, body: unknown) {
  const result = await api.post<any>(path, body, config)
  if (result?.code !== 200) throw Object.assign(new Error('Song request failed'), { code: result?.code })
  return result.data
}

export function sendSongEvent(id: string, event: string, context: PlaybackContext = {}, sessionId?: string, metadata?: Record<string, unknown>) {
  if (typeof window === 'undefined') return
  const body = {
    event_id: createGrowthEventId(), request_id: context.requestId || createGrowthEventId(),
    session_id: sessionId || getGrowthEventSessionId(), anonymous_id: getGrowthEventAnonymousId(),
    content_type: 'music', content_id: id, event_type: event, surface: context.surface || 'player',
    ...(context.position && context.position >= 1 ? { position: context.position } : {}), ...(metadata ? { metadata } : {}),
  }
  return deliverGrowthEvent(body, (original: unknown) => api.post('music/public/v1/growth/events', original, config))
}
